import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useArticles } from "components/articles/hooks/useArticles";
import ArticleForm from "components/articles/ArticleForm";

export default function EditArticle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loadArticleById, editArticle } = useArticles();
  const [data, setData] = useState(null);

  useEffect(() => {
    loadArticleById(id).then(setData);
  }, [id]);

  if (!data) return null;
  

  return (
    <ArticleForm
      initialData={data?.data}
      onSubmit={async (fd) => {
        await editArticle(id, fd);
        navigate("/admin/articles");
      }}
      onBack={() => navigate(-1)}
    />
  );
}
